<mat-dialog-content>
    <h2 mat-dialog-title>Update User Association</h2>
    @if(data.currentUser){
      <div class="current-association">
          <h3>Current Association</h3>
          <div class="user-info">
              <p><strong>Name:</strong> {{data.currentUser.firstName}} {{data.currentUser.lastName}}</p>
              <p><strong>Email:</strong> {{data.currentUser.email}}</p>
              <p><strong>User ID:</strong> {{data.currentUser.userId}}</p>
          </div>
      </div>
    }
    @if (!data.currentUser) {
        <div class="no-association">
            <p>No user currently associated with this person.</p>
        </div>
    }

    <div class="user-search-section">
        <h3>Search for User to Associate</h3>
        <app-user-search
            [selectionType]="'guid'"
            [userSearchTitle]="'Select User to Associate'"
            (userObjectSelected)="onUserSelected($event)"
        />
    </div>
    @if(selectedUser){
      <div class="selected-user">
          <h3>Selected User</h3>
          <div class="user-info">
              <p><strong>Name:</strong> {{selectedUser.firstName}} {{selectedUser.lastName}}</p>
              <p><strong>Email:</strong> {{selectedUser.email}}</p>
              <p><strong>User ID:</strong> {{selectedUser.userId}}</p>
              <p><strong>Company:</strong> {{selectedUser.primaryCompany?.name}}</p>
          </div>
      </div>
    }

</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-button (click)="cancel()" [disabled]="loading">Cancel</button>
    @if(data.currentUser){
      <button
        mat-button
        color="warn"
        (click)="removeAssociation()"
        [disabled]="loading || !data.currentUser">
        Remove Association
      </button>
    }

    <button
        mat-raised-button
        color="primary"
        (click)="updateAssociation()"
        [disabled]="loading || !selectedUser">
        {{data.currentUser ? 'Update' : 'Create'}} Association
    </button>
</mat-dialog-actions>
@if(loading){
  <div class="loading-overlay">
      <mat-spinner></mat-spinner>
  </div>
}

